<script>
export default {
    name: "Keyboard",
    data: () => ({}),
    methods: {
        press(val) {
            this.$emit('press', val)
        }
    }
}
</script>

<template>
    <div>
        <div class="px-0">
            <div class="d-flex keyboard-row">
                <button class="btn  keyboard-item " type="button" @click.prevent="press('1')">1</button>
                <button class="btn  keyboard-item " type="button" @click.prevent="press('2')">2</button>
                <button class="btn  keyboard-item " type="button" @click.prevent="press('3')">3</button>
            </div>
            <div class="d-flex keyboard-row">
                <button class="btn  keyboard-item " type="button" @click.prevent="press('4')">4</button>
                <button class="btn  keyboard-item " type="button" @click.prevent="press('5')">5</button>
                <button class="btn  keyboard-item " type="button" @click.prevent="press('6')">6</button>
            </div>
            <div class="d-flex keyboard-row">
                <button class="btn  keyboard-item " type="button" @click.prevent="press('7')">7</button>
                <button class="btn  keyboard-item " type="button" @click.prevent="press('8')">8</button>
                <button class="btn  keyboard-item " type="button" @click.prevent="press('9')">9</button>
            </div>
            <div class="d-flex keyboard-row">
                <button class="btn  keyboard-item " type="button" @click.prevent="press('*')">*</button>
                <button class="btn  keyboard-item " type="button" @click.prevent="press('0')">0</button>
                <button class="btn  keyboard-item " type="button" @click.prevent="press('#')">#</button>
            </div>
        </div>
    </div>
</template>


<style lang="scss" scoped>
.keyboard-item {
    width: 50px;
    height: 50px;
    background-color: #354052;
    border: #212833 solid 1px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    border-radius: 0;
    box-shadow: none;
    outline: none;
}
.keyboard-item:hover {
    background-color: #404d62;
    font-size: 120%;
}
.keyboard-item:focus {
    box-shadow: none;
    outline: none;
}
.keyboard-item:active {
    background-color: #4f5f79;
}
</style>
